import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan } from './glowUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Spin', 'techTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      [`${componentCls}-dot-item`]: {
        background: `${cyan[500]} !important`,
        boxShadow: `0 0 6px ${cyan[500]}80`,
      },

      [`${componentCls}-text`]: {
        color: `${cyan[400]} !important`,
      },
    },
  }
})
